// extracted by mini-css-extract-plugin
export default {"adsContainer":"AdsContainer_adsContainer__F-NvN"};